// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banners__img[data-v-7e94bc49]{display:block;width:100%;-o-object-fit:contain;object-fit:contain;opacity:0}.banners__img.loaded[data-v-7e94bc49]{opacity:1;transition:opacity .25s ease-in-out;-moz-transition:opacity .25s ease-in-out;-webkit-transition:opacity .25s ease-in-out}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
